import map from "lodash/fp/map";
import assign from "lodash/fp/assign";
import moment from "moment";
import constants from "../../core/constants";

class PackagesPageTransform {
  constructor() {
    "ngInject";

    this.item = { title: "Package", state: "package" };

    this.fields = [
      { title: "Package Name", name: "name" },
      { title: "Start Date", name: "start_date", isSortable: true },
      { title: "End Date", name: "expiration_date", isSortable: true },
      {
        title: "Supported Ride Types",
        name: "supported_ride",
        className: "capitalize",
      },
      { title: "Package type", name: "package_type", className: "capitalize" },
      { title: "City", name: "city" },
      { title: "Active", name: "is_active" },
    ];

    this.filters = [
      {
        name: "search",
        title: "Search by name",
        icon: "search",
        isSearch: true,
        resource: "Packages",
        state: "package",
        size: 30,
      },
      {
        name: "supported_ride",
        title: "Supported Ride Types",
        icon: "directions_car",
        list: "supportedRideTypes",
        multiple: true,
      },
      {
        name: "package_type",
        title: "Package Types",
        list: "supportedPackageTypes",
        multiple: true,
      },
    ];

    this.addOptions = {
      title: "Add New Package",
      icon: "add",
      fields: [
        {
          name: "city",
          title: "City",
          resource: "City",
          isResource: true,
          isRequired: true,
        },
        {
          name: "name_i18n",
          title: "Name",
          type: "text",
          isI18nText: true,
          isRequired: true,
        },
        {
          name: "start_date",
          title: "Select start date",
          icon: "date_range",
          isRequired: true,
          date: true,
          hasRange: false,
        },
        {
          name: "expiration_date",
          title: "Select end date",
          icon: "date_range",
          date: true,
          isRequired: true,
          hasRange: false,
        },
        {
          name: "package_type",
          title: "Package Types",
          icon: "directions_car",
          list: "supportedPackageTypes",
          isRequired: true,
        },
        {
          name: "supported_ride",
          title: "Supported Ride Types",
          list: "supportedRideTypes",
          isRequired: true,
          multiple: true,
        },
      ],
    };
  }

  justify(data) {
    const getSource = (item) => {
      item = assign({ _id: item._id }, item._source);
      item.name = item.name_i18n.en;
      item.start_date =
        item.start_date && moment(item.start_date).format(constants.dateFormat);
      item.expiration_date =
        item.expiration_date &&
        moment(item.expiration_date).format(constants.dateFormat);
      item.supported_ride = item.supported_ride.join(", ");
      item.is_active = item.is_active ? "Yes" : "No";

      return item;
    };

    return map(getSource)(data);
  }
}

export default PackagesPageTransform;



// WEBPACK FOOTER //
// ./src/pages/packages/packages.transforms.js